import Vue from 'vue'
import Vuex, { StoreOptions } from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import { RootState } from './types'
import { mutations } from './mutations'
import { auth } from './auth'
import { books } from './books'
import { checkin } from './check-in'
import { offerCarts } from './offer-carts'
import { offers } from './offers'
import { sellers } from './sellers'

Vue.use(Vuex)

const store: StoreOptions<RootState> = {
  state: {
    error: null,
  },
  mutations,
  modules: {
    auth,
    books,
    checkin,
    offerCarts,
    offers,
    sellers,
  },
  plugins: [createPersistedState()],
}

export default new Vuex.Store<RootState>(store)
